import React from "react";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import IntlMessages from "../../../services/intlMesseges";
import * as userActions from "../../../redux/actions/user-actions";
import * as AdminActions from "../../../redux/actions/admin-actions";
import * as RolesActions from "../../../redux/actions/roles-actions";
import * as OrgActions from "../../../redux/actions/organization-actions";
import * as paginationActions from "../../../redux/actions/pagination-actions";
import API from "../../../redux/api/admin-api";
import { notifyUser } from "../../../services/notification-service";
import * as Permission from "../../../services/permissions";
import AppLocale from "../../../languageProvider";
import * as travellerActions from "../../../redux/actions/travellers-actions";
import * as b2cActions from "../../../redux/actions/b2c-actions";
import EmployeeMap from "../../admin-dash/organizations/edit-organization/employees/employees-map";

import {
  Typography,
  Form,
  Input,
  Select,
  Button,
  Row,
  Col,
  Spin,
  DatePicker,
  TreeSelect,
  Checkbox,
  
  Modal,
  Radio,
  Tabs,
} from "antd";
import moment from "moment";
const { confirm } = Modal;
const dateFormat = "MM/DD/YYYY";
const dateFormatY = "YYYY/MM/DD";
const { Option } = Select;
const { TabPane } = Tabs;
var validator = require("email-validator");
class EditEmployeesDependent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentSelectedRole: null,
      dataLoaded: false,
      fetching: false,
      loading: true,
      confirmDirty: false,
      sendEmailForNew: true,
      sendEmailNew: false,
      userId: 0,
      companyId: 0,
      displayEmployeesAssignedRow: 'none',
      displayRecieveEmailRow: 'none',
      defaultAssignedOrgs: [],
      divisionList: [],
      countries: [],
      allRoles: [],
      assignedDivisionsAuto: false,
      genderList: [],
      userexist: false,
      showModal: false,
      disableGender: false,
      isEmailChanged: false,
      newEmail: '',
      radioChildValue: 'self',
      UserListData: [],
      selectedRelation: '',
      parentId: null,
      displayParent: false,
      disableEmployee: false,
      activeTabKey: 'Edit'
    };
  }

  async componentDidMount() {
    const storedDataString = localStorage.getItem('user');
    const storedData = storedDataString ? JSON.parse(storedDataString) : null;
    // Set the parentId in the state
    if (storedData) {
      this.setState({
        parentId: storedData.parentOrgId
      });
    }

    const { filters, pagination, sorter } = this.props;
    if (this.state.dataLoaded === false) {
      let _companyIdTemp = 0;
      let countriesListTemp = await API.getCountriesList();
      let userRolesList = await this.props.getAllExternalRoles();
      this.setState({
        allRoles: userRolesList.filter((role) => role.name != 'Super Admin'),
        countries: countriesListTemp.countries
      });
      // if (
      //   this.props.match &&
      //   this.props.match &&
      //   this.props.match.params &&
      //   this.props.match.params.id &&
      //   this.props.match.params.id !== 'new'
      // ) {
      const user = await this.props.getUser(this.props.match.params.id);
      if (user.data && user.data.role && user.data.role.indexOf('Employee') > -1) {
        if (user.data.relatedParentId) {
          this.setState({ radioChildValue: 'child' });
        }
        this.setState({ displayParent: true, disableEmployee: true });
      } else {
        this.setState({ displayParent: false, disableEmployee: false });
      }
      if (user.data.relatedParentId == 0 || user.data.relatedParentId == null) {
        this.setState({ disableEmployee: false });
      }

      if (user.error && user.error.message) {
        this.props.history.goBack();
        notifyUser(user.error.message, 'error');
      } else {
        this.setState(user.data);
        _companyIdTemp = user.data.companyId;
        this.setState({ currentSelectedRole: user.data.role });

        var tempDefaultOrgs = [];
        if (user.data && user.data.assignedOrganizations) {
          for (var o = 0; o < user.data.assignedOrganizations.length; o++) {
            tempDefaultOrgs.push({
              key: user.data.assignedOrganizations[o].branchId,
              value: user.data.assignedOrganizations[o].branchId,
              label: user.data.assignedOrganizations[o].branchName
            });
          }
          this.setState({ defaultAssignedOrgs: tempDefaultOrgs });
        }
      }
      //   } else {
      //     _companyIdTemp =
      //       this.props.match.params.divid && this.props.match.params.divid > 0
      //         ? this.props.match.params.divid
      //         : this.props.match.params.orgid;
      //     this.setState({
      //       companyId: _companyIdTemp
      //     });
      //  // }
      // this.loadDivisions(_companyIdTemp);
      this.setState({ loading: false, dataLoaded: true });
    }
    this.props.getGendersList().then((response) => {
      this.setState({ genderList: response });
    });
  }

  handleTabChange = (key) => {
    this.setState({
      activeTabKey: key
    });
  };

  submitFormEdit = (data) => {
    const { language } = this.props;
    const currentAppLocale = AppLocale[language.locale];
    this.props
      .updateUser(data)
      .then((response) => {
        if (response.success == false) {
          notifyUser(response.data, 'error');
          this.setState({ loading: false });
        } else {
          this.props.history.push('./../');
          this.setState({ loading: false });
          notifyUser(currentAppLocale.messages['admin.employee.edit'], 'success');
        }
      })
      .catch((_err) => {
        this.setState({ loading: false });
      });
  };

  onEmailChange = (email) => {
    this.setState({ isEmailChanged: true, newEmail: email });
  };

  handleEmailChange(email) {
    this.setState({ disableGender: false });
    this.setState({ isEmailChanged: true, newEmail: email });

    // var email = evt.target.value;
    if (validator.validate(email)) {
      if (this.debouncedValidateTravellerEmail) {
        clearTimeout(this.debouncedValidateTravellerEmail);
      }

      this.debouncedValidateTravellerEmail = setTimeout(async () => {
        try {
          let travllerdata = await this.props.validateTravellerEmail(email);
          this.setState({ userexist: travllerdata });
          this.setState({ isEmailChanged: true, newEmail: email });

          if (travllerdata.userExist) {
            this.props.form.setFieldsValue({ firstName: travllerdata.firstName });
            this.props.form.setFieldsValue({ lastName: travllerdata.lastName });
            if (travllerdata.gender != null) {
              this.setState({ disableGender: true });
              this.props.form.setFieldsValue({ gender: travllerdata.gender });
            }
            this.handleShowModal(); // Show the confirmation popup
          }
        } catch (error) {
          console.error('Error while fetching traveller data:', error);
        }
      }, 800);
    }
  }

  handleRelatedChange = (e) => {
    const value = e.target.value;
    if (value === 'self') {
      this.setState({ relatedParentId: null, disableEmployee: false }, () => {});
    } else {
      this.props.form.setFields({
        userName: { errors: null },
        contactNo: { errors: null }
      });
    }
    this.setState({ radioChildValue: value }, () => {});
  };

  handleShowModal = () => {
    this.setState({ showModal: true });
  };

  handleHideModal = () => {
    this.setState({ userexist: '', showModal: false, disableGender: false });
    this.props.form.setFieldsValue({ userName: '' });
  };

  handleConfirmAction = () => {
    this.setState({ showModal: false });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        Object.keys(values).map(function(key, _idx) {
          if (values[key] == null) {
            values[key] = '';
          } else {
            if (typeof values[key] == 'string') {
              values[key] = values[key].trim();
            }
          }
        });
        values['IsSendWelcomeEmail'] = this.state.sendEmailForNew;
        values['dateOfBirth'] = values['dateOfBirth'].format('YYYY-MM-DD');
        values['RelatedParentId'] =
          this.state && this.state.selectedRelation ? this.state.selectedRelation : this.state.relatedParentId;
        // values['RelatedParentId'] = this.state.relatedParentId ? this.state.relatedParentId : null;
        //values['RelatedParent']= this.state.radioChildValue ? this.state.RelatedParentId == null : this.state.RelatedParentId ;
        this.setState({ loading: true });
        values['isNotifyOnBooking'] = this.state.sendEmailNew;
        this.setState({ loading: true });
        values['userId'] = this.state.userId;
        values['identityId'] = this.state.identityId;
        values['assignedOrganizations'] = this.state.assignedOrganizations || [];
        values['companyId'] = this.state.companyId;
        values['userName'] = this.state.isEmailChanged ? this.state.newEmail : this.state.userName;
        this.submitFormEdit(values);
      }
    });
  };

  handleSelectedRelation = (selected) => {
    let selectedfield = selected;
    this.setState({
      selectedRelation: selectedfield
    });
  };

  handleContactExistance(rule, value, callback) {
    //const re = /^[0-9']+$/;
    const re = /^(?=[+0-9]*$)(?!.*[<>'"/;`%~@#$^*()_=[\]{}|\\,.?: -])/;
    var test = re.test(value);
    if (value !== undefined && value !== '' && (value.length < 6 || test === false)) {
      callback(<IntlMessages id='admin.phonenumber.valid'></IntlMessages>);
    } else {
      callback();
    }
  }

  onChangeSendEmailToggle = (e) => {
    let _sendEmailForNew = this.state.sendEmailForNew;
    _sendEmailForNew = e.target.value;
    this.setState({ sendEmailForNew: _sendEmailForNew });
  };

  onChangeSendEmail = (e) => {
    let _sendEmailNew = this.state.sendEmailNew;
    _sendEmailNew = e.target.value;
    this.setState({ sendEmailNew: _sendEmailNew });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { formLayout } = this.state;
    const formItemLayout =
      formLayout === 'horizontal'
        ? {
            labelCol: { span: 4 },
            wrapperCol: { span: 14 }
          }
        : null;
    let roleExists = -1;
    roleExists = this.state.allRoles.findIndex((el) => this.state.roleId === el.id);
    if (roleExists > -1) {
      roleExists = true;
    } else {
      roleExists = false;
    }
    const countriesSelector = getFieldDecorator('countryId', {
      initialValue: this.state.countryId
    })(
      <Select
        showSearch
        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
      >
        {this.state.countries.map(function(item) {
          return (
            <Option key={item.countryId} value={item.countryId}>
              {item.countryName}
            </Option>
          );
        })}
      </Select>
    );

    return (
      <Tabs
        defaultActiveKey={this.state.activeTabKey}
        activeKey={this.state.activeTabKey}
        size='large'
        onChange={this.handleTabChange}
      >
        <TabPane tab={'Edit'} key='Edit'>
          <div>
            <Row gutter={24}>
              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <Typography.Title level={4}>Edit Dependent</Typography.Title>
              </Col>
              <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                <Button
                  type='primary'
                  className='right-fl'
                  htmlType='button'
                  onClick={() => this.props.history.push('../')}
                >
                  <IntlMessages id='admin.userlisting.back' />
                </Button>
              </Col>
            </Row>
            <hr />
            <div>
              <Spin spinning={this.state.loading}>
                <Form layout={formLayout} onSubmit={this.handleSubmit}>
                  <Row gutter={24}>
                    <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                      <Form.Item {...formItemLayout} label={<IntlMessages id='admin.travelmanager.id' />}>
                        {getFieldDecorator('employeeId', {
                          rules: [
                            {
                              required: true,
                              message: <IntlMessages id='admin.input.required' />
                            }
                          ],
                          initialValue: this.state.employeeId === null ? '' : this.state.employeeId
                        })(<Input maxLength={20} />)}
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                      <Form.Item {...formItemLayout} label={<IntlMessages id='admin.userlisting.firstName' />}>
                        {getFieldDecorator('firstName', {
                          rules: [
                            {
                              whitespace: true,
                              required: true,
                              message: <IntlMessages id='admin.input.required' />
                            },
                            {
                              pattern: new RegExp(/^(\S.*)[a-zA-Z-.']+$/),
                              message: <IntlMessages id='admin.name.valid'></IntlMessages>
                            }
                          ],
                          initialValue: this.state.userexist.userExist
                            ? this.state.userexist.firstName
                            : this.state.firstName === null
                            ? ''
                            : this.state.firstName
                        })(
                          <Input
                            placeholder={
                              this.state.userexist.userExist ? this.state.userexist.firstName : 'Enter First Name'
                            }
                            disabled={
                              this.props.location.pathname.includes('new') ? this.state.userexist.userExist : false
                            }
                            maxLength={50}
                          />
                        )}
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                      <Form.Item {...formItemLayout} label={<IntlMessages id='admin.userlisting.lastName' />}>
                        {getFieldDecorator('lastName', {
                          rules: [
                            {
                              whitespace: true,
                              required: true,
                              message: <IntlMessages id='admin.input.required' />
                            },
                            {
                              pattern: new RegExp(/^(\S.*)[a-zA-Z-.']+$/),
                              message: <IntlMessages id='admin.lname.valid'></IntlMessages>
                            }
                          ],
                          initialValue: this.state.userexist.userExist
                            ? this.state.userexist.lastName
                            : this.state.lastName === null
                            ? ''
                            : this.state.lastName
                        })(
                          <Input
                            placeholder={
                              this.state.userexist.userExist ? this.state.userexist.lastName : 'Enter First Name'
                            }
                            disabled={
                              this.props.location.pathname.includes('new') ? this.state.userexist.userExist : false
                            }
                            maxLength={50}
                          />
                        )}
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row gutter={24}>
                    <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                      <Form.Item {...formItemLayout} label={<IntlMessages id='admin.userlisting.email' />}>
                        {getFieldDecorator('userName', {
                          rules: [
                            {
                              type: 'email',
                              message: <IntlMessages id='admin.email.valid'></IntlMessages>
                            },
                            {
                              required: this.state.radioChildValue == 'self' ? true : false,
                              message: <IntlMessages id='admin.input.required' />
                            }
                          ],
                          initialValue:
                            this.state.userName === null
                              ? ''
                              : this.state.isParent
                              ? this.state.userName
                              : this.state.parentEmail
                        })(
                          this.state.userId === 0 || (Permission.emailEditAllowded() && this.state.isParent) ? (
                            <Input
                              // onBlur={(e) => this._onBlur(e.target.value)}
                              onChange={(e) => this.handleEmailChange(e.target.value)}
                            />
                          ) : (
                            <Input disabled />
                          )
                        )}
                      </Form.Item>
                      <Modal
                        visible={this.state.showModal}
                        onCancel={this.handleHideModal}
                        onOk={this.handleConfirmAction}
                        okText='Confirm'
                        cancelText='Cancel'
                        className='modalStyle'
                      >
                        <p>
                          This email already exists with other organization, Are you sure you want to use this email?
                        </p>
                      </Modal>
                    </Col>
                    <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                      <Form.Item {...formItemLayout} label={<IntlMessages id='admin.userlisting.phonenumber' />}>
                        {getFieldDecorator('contactNo', {
                          rules: [
                            {
                              validator: this.handleContactExistance
                            },
                            {
                              whitespace: true,
                              required: this.state.radioChildValue == 'self' ? true : false,
                              message: <IntlMessages id='admin.input.required' />
                            }
                          ],
                          initialValue: this.state.contactNo === null ? '' : this.state.contactNo
                        })(<Input maxLength={15} style={{ width: '100%' }} />)}
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                      <Form.Item {...formItemLayout} label={<IntlMessages id='admin.employee.dob' />}>
                        {getFieldDecorator('dateOfBirth', {
                          rules: [
                            {
                              required: true,
                              message: <IntlMessages id='admin.input.required' />
                            }
                          ],
                          initialValue:
                            this.state.dateOfBirth != null ? moment(this.state.dateOfBirth, dateFormatY) : ''
                        })(
                          <DatePicker
                            disabledDate={(current) => {
                              return current && current > moment().subtract(1, 'days');
                            }}
                            placeholder='-select-'
                            format={dateFormat}
                          />
                        )}
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row gutter={24}>
                    <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                      <Form.Item {...formItemLayout} label={<IntlMessages id='admin.userlisting.address' />}>
                        {getFieldDecorator('address', {
                          initialValue: this.state.address === null ? '' : this.state.address
                        })(<Input />)}
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                      <Form.Item label={<IntlMessages id='admin.userlisting.country' />}>{countriesSelector}</Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                      <Form.Item label={<IntlMessages id='admin.primaryaddress.state' />}>
                        {getFieldDecorator('state', {
                          initialValue: this.state.state === null ? '' : this.state.state
                        })(<Input />)}
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row gutter={24}>
                    {this.state.role != 'Admin' && (
                      <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                        <Form.Item {...formItemLayout} label={<IntlMessages id='admin.userlisting.role' />}>
                          {getFieldDecorator('roleId', {
                            rules: [
                              {
                                required: true,
                                message: <IntlMessages id='admin.input.required' />
                              }
                            ],
                            initialValue: roleExists ? this.state.roleId : null
                          })(
                            <Select disabled={this.state.disableEmployee} placeholder='-select-'>
                              {this.state.allRoles.map(function(item) {
                                return item.name == 'Agent' || item.name == 'Hybrid Admin' ? (
                                  ''
                                ) : (
                                  <Option key={item.id}>{item.name}</Option>
                                );
                                // return (
                                //   <Option key={item.id}>{item.name}</Option>
                                // );
                              })}
                            </Select>
                          )}
                        </Form.Item>
                      </Col>
                    )}
                    <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                      <Form.Item label='Gender'>
                        {getFieldDecorator('gender', {
                          rules: [
                            {
                              required: true,
                              message: 'Please select your Gender!'
                            }
                          ],
                          initialValue: this.state.userexist.userExist
                            ? this.state.userexist.gender
                            : this.state.gender == 0
                            ? ''
                            : this.state.gender
                          //initialValue: this.state.userexist.userExist ? this.state.userexist.gender : this.state.gender
                        })(
                          <Select
                            showSearch
                            placeholder='Please select gender'
                            filterOption={(input, option) =>
                              option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                            disabled={this.state.disableGender}
                          >
                            {this.state.genderList.map(function(gender) {
                              return (
                                <Option key={gender.id} value={gender.id}>
                                  {gender.name}
                                </Option>
                              );
                            })}
                          </Select>
                        )}
                      </Form.Item>
                    </Col>
                  </Row>
                  <div className='clear'>&nbsp;</div>
                  <Typography.Title level={3}>
                    <IntlMessages id='admin.employee.alternate.contact' />
                  </Typography.Title>
                  <Row gutter={24}>
                    <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                      <Form.Item {...formItemLayout} label={<IntlMessages id='admin.userlisting.firstName' />}>
                        {getFieldDecorator('emergencyFirstName', {
                          rules: [
                            {
                              pattern: new RegExp(/^(\S.*)[a-zA-Z-.']+$/),
                              message: <IntlMessages id='admin.name.valid'></IntlMessages>
                            }
                          ],
                          initialValue: this.state.emergencyFirstName === null ? '' : this.state.emergencyFirstName
                        })(<Input maxLength={50} />)}
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                      <Form.Item {...formItemLayout} label={<IntlMessages id='admin.userlisting.lastName' />}>
                        {getFieldDecorator('emergencyLastName', {
                          rules: [
                            {
                              pattern: new RegExp(/^(\S.*)[a-zA-Z-.']+$/),
                              message: <IntlMessages id='admin.lname.valid'></IntlMessages>
                            }
                          ],
                          initialValue: this.state.emergencyLastName === null ? '' : this.state.emergencyLastName
                        })(<Input maxLength={50} />)}
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                      <Form.Item {...formItemLayout} label={<IntlMessages id='admin.userlisting.email' />}>
                        {getFieldDecorator('emergencyEmail', {
                          rules: [
                            {
                              type: 'email',
                              message: <IntlMessages id='admin.email.valid'></IntlMessages>
                            }
                          ],
                          initialValue: this.state.emergencyEmail === null ? '' : this.state.emergencyEmail
                        })(this.state.emergencyEmail === 0 ? <Input /> : <Input />)}
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row gutter={24}>
                    <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                      <Form.Item {...formItemLayout} label={<IntlMessages id='admin.primaryaddress.phonenumber' />}>
                        {getFieldDecorator('emergencyContactNo', {
                          rules: [
                            {
                              validator: this.handleContactExistance
                            }
                          ],
                          initialValue: this.state.emergencyContactNo === null ? '' : this.state.emergencyContactNo
                        })(<Input maxLength={15} style={{ width: '100%' }} />)}
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                      <Form.Item {...formItemLayout} label={<IntlMessages id='admin.manageTravellers.Realationship' />}>
                        {getFieldDecorator('emergencyRelationship', {
                          rules: [
                            {
                              pattern: new RegExp(/^(\S.*)[a-zA-Z-.']+$/),
                              message: <IntlMessages id='admin.lname.valid'></IntlMessages>
                            }
                          ],
                          initialValue:
                            this.state.emergencyRelationship === null ? '' : this.state.emergencyRelationship
                        })(<Input />)}
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Form.Item>
                        <Button
                          type='primary'
                          style={{
                            display: 'inline-block',
                            marginRight: '10px'
                          }}
                          className='def-blue'
                          htmlType='submit'
                        >
                          {this.state.userId > 0 ? (
                            <IntlMessages id='admin.userlisting.update' />
                          ) : (
                            <IntlMessages id='admin.userlisting.add' />
                          )}
                        </Button>
                      </Form.Item>
                    </Col>
                  </Row>
                </Form>
              </Spin>
            </div>
          </div>
        </TabPane>

        <TabPane tab={'Map'} key='Map'>
          <EmployeeMap />{' '}
        </TabPane>
      </Tabs>
    );
  }
}

EditEmployeesDependent.propTypes = {
  location: PropTypes.object,
  updateUser: PropTypes.func,
  getAllExternalRoles: PropTypes.func,
  getUserListing: PropTypes.func,
};

function mapStateToProps(state) {
  return { ...state.language, ...state.user , ...state.pagination,};
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      ...userActions,
      ...RolesActions,
      ...OrgActions,
      ...travellerActions,
      ...AdminActions,
      ...b2cActions,
      ...paginationActions
    },
    dispatch
  );
}
const WrappedForm = Form.create({ name: "edit-organization-employee" })(
  EditEmployeesDependent
);

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(
    WrappedForm
  )
);
